import { Card } from "@merge-api/merge-javascript-shared";
import { CommonModelDiffRunExecution } from "../../entities";

import TypeRow from "./TypeRow";
import TotalModelCountRow from "./TotalModelCountRow";
import TotalAPIRequestCountRow from "./TotalAPIRequestCountRow";

interface ComparisonSummaryProps {
  candidateTitle?: string;
  diffRun: CommonModelDiffRunExecution;
  integrationID: string;
}

const ComparisonSummary = ({
  candidateTitle = "Staged",
  diffRun,
  integrationID,
}: ComparisonSummaryProps) => {
  // const derived from state
  const stagedBlueprintVersionID = diffRun.staged_blueprint_version_id;
  const publishedBlueprintVersionID = diffRun.published_blueprint_version_id;

  return (
    <Card variant="shadow">
      <TypeRow
        candidateTitle={candidateTitle}
        stagedBlueprintVersionID={stagedBlueprintVersionID}
        publishedBlueprintVersionID={publishedBlueprintVersionID}
        integrationID={integrationID}
      />
      <hr className="h-[0.5px] m-0 text-gray-40" />
      <TotalModelCountRow diffRunResults={diffRun.results} />
      <hr className="h-[0.5px] m-0 text-gray-40" />
      <TotalAPIRequestCountRow
        totalStagedAPIRequests={diffRun.results.staged_blueprint_version_api_requests}
        totalPublishedAPIRequests={diffRun.results.published_blueprint_version_api_requests}
      />
    </Card>
  );
};

export default ComparisonSummary;
